import { Directive, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { HttpLoadingService } from '@core/services/http-loading.service';

/**
 * `disabled` sur les `button.btn` pendant l’envoi d’au moins une requête POST, PUT, PATCH ou DELETE
 * (voir `HTTP_BTN_LOADING_METHODS` et `HttpLoadingInterceptor`). Aucun indicateur visuel.
 * Exclure : classe `btn-no-http-loading`.
 */
@Directive({
  selector: 'button.btn:not(.btn-no-http-loading)'
})
export class BtnHttpLoadingDirective implements OnInit, OnDestroy {
  private _sub: Subscription;

  constructor(private _el: ElementRef<HTMLButtonElement>, private _httpLoading: HttpLoadingService) {}

  ngOnInit(): void {
    const btn = this._el.nativeElement;

    this._sub = this._httpLoading.pending$.subscribe(count => {
      btn.disabled = count > 0;
    });
  }

  ngOnDestroy(): void {
    this._sub?.unsubscribe();
  }
}
